module.exports = __webpack_public_path__ + "img/hero-image.7365e31c.jpg";